<template>
  <section>
    <el-row class="warp">
      <el-col :span="6" class="warp-breadcrum">
          <el-breadcrumb separator="/">
            <!-- <el-breadcrumb-item :to="{ path: '/' }">
              <b>首页</b>
            </el-breadcrumb-item> -->
            <el-breadcrumb-item>审核卷期列表</el-breadcrumb-item>
          </el-breadcrumb>
      </el-col>
    </el-row>  

      <!--工具条 begin-->
    <el-row class="warp">
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
          <el-form :inline="true" :model="searchForm" class="demo-form-inline">
              <el-form-item label="出版商：" prop="insName">
                  <el-select v-model="searchForm.insId" filterable  placeholder="出版商" @change="insSelectChanged">
                      <el-option
                      v-for="item in allIns"
                      :key="item.insId"
                      :label="item.insName"
                      :value="item.insId"
                      ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="期刊：" prop="journalName">
                  <el-select v-model="searchForm.journalId" filterable  placeholder="请先选择出版商" @change="journalSelectChanged">
                      <el-option
                      v-for="item in journals"
                      :key="item.journalId"
                      :label="item.journalName"
                      :value="item.journalId"
                      ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="年份：" prop="yearValue">
                  <el-date-picker
                      v-model="searchForm.yearValue"
                      type="year"
                      value-format="yyyy"
                      placeholder="选择年">
                  </el-date-picker>
              </el-form-item>
              <el-form-item label="上传权限：" prop="label">
                  <el-select v-model="searchForm.flag" filterable disabled placeholder="请选择自动转换类型">
                      <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      :disabled="item.disabled"
                      ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="mini" type="primary" @click="findResult(null)">查询</el-button>
              </el-form-item>
              <el-form-item>
                  <el-button size="mini" type="primary" @click="refresh(null)">刷新</el-button>
              </el-form-item>
          </el-form>
      </el-col>
      <!-- 
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
          <el-upload
              class="upload-demo"
              ref="upload"
              :action="packageUrl(flag)"
              accept="zip"
              :limit="1"
              :file-list="fileList"
              :on-success="uploadApkSuccess"
              :auto-upload="false"
              >
              <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
              <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
              <div slot="tip" class="el-upload__tip">只能上传zip文件</div>
          </el-upload>
      </el-col>
      --> 
      <!--工具条 end-->

      <!-- 列表显示 begin-->
      <el-col :span="24" class="tablebar" style="padding-bottom: 0px;">
        <el-table :data="issueList" style="width: 100%;overflow: auto;" stripe highlight-current-row v-loading="tableLoading" class="tablebar">
          <!-- 第一行显示数据 -->
          <el-table-column
            type="index"
            width="50">
          </el-table-column>
          <el-table-column prop="journalName" label="期刊" sortable align="center"></el-table-column>
          <el-table-column prop="issn" label="Issn" sortable align="center"></el-table-column>
          <el-table-column prop="year" label="年/Year" sortable align="center"></el-table-column>
          <el-table-column prop="issue" label="期/Issue" sortable align="center"></el-table-column>
          <el-table-column prop="articleCount" label="已上传文章总数" sortable align="center"></el-table-column>
          <el-table-column prop="uploadStatus" label="状态" sortable align="center">
            <template slot-scope="scope">
                <el-tag
                    :type="scope.row.uploadStatus === 2 ? 'success' : 'danger'"
                    disable-transitions>
                    {{scope.row.uploadInfo}}
                </el-tag>
              </template>
          </el-table-column>
          <!-- 操作按钮 -->
          <el-table-column label="操作" width="240" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" :style="(scope.row.uploadStatus === 2) ? { display: '' } : { display: 'none' }" @click="showInfo(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
          <div slot="empty" class="empty">
            <el-empty description="暂无数据"></el-empty>
          </div>
        </el-table>
      </el-col>
      <!-- 列表显示 end-->
    </el-row>
  </section>
</template>

<script>
import API_INS from "../../../api/api_institution";
import API_JOURNAL from "../../../api/api_journal";
import API_JOURNALDATA from "../../../api/api_journalData";

export default {
  data() {
    return {
        options: [{
            value: '1',
            label: '仁和',
          }, {
            value: '2',
            label: '玛格',
          }, {
            value: '3',
            label: 'SciEngine',
        }],
        searchForm:{
          insId:"",
          journalId:"",
          yearValue:"2022",
          //上传的转换类型，0代表不转换，1代表仁和，2代表玛格
          flag: '1',
          audit:'',
        },
        allIns:[],
        journals:[],
        issueList: [],
        
        //页面载入状态
        tableLoading: false,
        fileList: [],
        timer:null,
      //在此添加新的数据定义
    };
  },

  methods: {
    //获取机构
    findInstitutions(){
        let that = this;
        API_INS.getAuditInstitutions()
        .then(res=>{
            if(res && res.ins){
            that.allIns = Object.values(res.ins);
            }
            if(that.searchForm.journalId == undefined  || that.searchForm.yearValue == undefined ){
              console.log("新界面");
              //新界面，取数组的第一个展示
              console.log("that.allIns[0]:",that.allIns[0]);
              that.searchForm.insId = that.allIns[0].insId;
              that.findJournalByInsId(that.searchForm.insId);
            }
            else{
              console.log("老界面");
              console.log("insId:",that.searchForm.insId);
              console.log("journalId",that.searchForm.journalId);
              console.log("yearValue",that.searchForm.yearValue);
              that.findJournalByInsId(that.searchForm.insId);
              that.findResult();
            }
        })
        .catch(e=>{
            this.$message({
            showClose:true,
            type:"error",
            message:"请求findInstitutions()出现异常",
            duration:2000
            });
        });
    },

    //根据机构Id获取与其关联的期刊
    findJournalByInsId(_insId){
        let that = this;
        let params = {
            insId: _insId
        };
        API_JOURNAL.getAuditJournalByInsId(params)
        .then(res=>{
            if(res && res.journal){
              that.journals = Object.values(res.journal);
              console.log(
                  "......findJournalByInsId:" + JSON.stringify(that.journals)
                  );
              if(that.searchForm.journalId == undefined  || that.searchForm.yearValue == undefined ){
                console.log("新界面");
                //新界面，取数组的第一个展示
                that.searchForm.journalId = that.journals[0].journalId;
                that.searchForm.flag = that.journals[0].uploadType;
                that.searchForm.audit = that.journals[0].audit;

                //获取当前年份
                let year = new Date().getFullYear();
                console.log("year:",year);
                that.searchForm.yearValue = year;
                that.findResult();
              }
              else{
                console.log("老界面");
                console.log("insId:",this.searchForm.insId);
                console.log("journalId",this.searchForm.journalId);
                console.log("yearValue",this.searchForm.yearValue);
                that.searchForm.flag = that.journals[0].uploadType;
                that.searchForm.audit = that.journals[0].audit;
              }  
            }
        })
        .catch(e=>{
            this.$message({
            showClose:true,
            type:"error",
            message:"请求findJournalByInsId()出现异常",
            duration:2000
            });
        });
    },

    findJournalByJournalId(_journalId){
        let that = this;
        let params = {
            journalId: _journalId
        };
        API_JOURNAL.getJournal(params)
        .then(res=>{
            if(res && res.journalName){
              that.searchForm.journalId = res.journalId;
              that.searchForm.flag = res.uploadType;
              that.searchForm.audit = res.audit;
            }
        })
        .catch(e=>{
            this.$message({
            showClose:true,
            type:"error",
            message:"请求findJournalByJournalId()出现异常",
            duration:2000
            });
        });
    },

    insSelectChanged(value){
        this.findJournalByInsId(value);
    },

    journalSelectChanged(value){
        this.findJournalByJournalId(value);
    },

    findResult(){
      let that = this;
      this.tableLoading = true
      let params = {
        yearValue: that.searchForm.yearValue,
        journalId: that.searchForm.journalId,
      };
      console.log("......findResult params:" + JSON.stringify(params));
      //发送http请求
      API_JOURNALDATA.getJournalIssueList(params)
        .then(res => {
            if(res && res.issueList){
                that.issueList = Object.values(res.issueList);
                console.log(
                    "......findResult:" + JSON.stringify(that.issueList)
                );
            }
        })
        .catch(e => {
          this.$message({
            showClose: true,
            type: "error",
            message: "请求findResult()出现异常",
            duration: 2000
          });
        }).finally(()=>{
          this.tableLoading = false
        });
    },

    //显示编辑对话框
    showInfo: function(row) {
      this.$router.push({
        path: '/resultMng/dataAuditInfo', 
        query: {journalName: row.journalName, issn: row.issn, year: row.year, issue: row.issue, 
        journalId: this.searchForm.journalId, insId: this.searchForm.insId, audit: this.searchForm.audit}})
    },

    dataInit(){
      let that = this;
      that.searchForm.yearValue = this.$route.query.yearValue;
      that.searchForm.journalId = this.$route.query.journalId;
      that.searchForm.insId = this.$route.query.insId;
    },

    refresh(){
      this.findResult();
    }

  },
  mounted() {
    this.timer = setInterval(() => {
       setTimeout(this.refresh, 0)
   }, 1000*60)
  },
  created(){
    this.dataInit();
    this.findInstitutions();
  },
  watch:{
    "searchForm.yearValue"(val){
      this.searchForm.yearValue = "" + val;
    }
  }
};
</script>

<style scoped>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>


// WEBPACK FOOTER //
// src/views/SysMng/Data/AuditManage.vue